import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Chip from "@mui/material/Chip";
import InputNumber from "../../../shared/components/inputs/InputNumber/InputNumber";
import { useLoading } from "../../../shared/context/LoadingContext";
import { formatarDataGuardada } from "../../../shared/util/datasGuardadas";
import moment from "moment";
import InventoryIcon from "@mui/icons-material/Inventory";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function ModalTransferenciaStock({
  open,
  handleClose,
  stock,
  dadosProdutoFiltrado,
  sendRequest,
  auth,
  clinica,
  atualizarStock,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [quantidade, setQuantidade] = useState(1);
  const [localizacaoDestinoId, setLocalizacaoDestinoId] = useState("");
  const [todasLocalizacoes, setTodasLocalizacoes] = useState([]);

  const stockRetirada = dadosProdutoFiltrado.selecionado;
  const nomeLote = dadosProdutoFiltrado.nomeLote;

  const selectedLoteInfo =
    stockRetirada?.lotes?.find((l) => l.lote === nomeLote) || {};

  const localizacaoOrigemId = dadosProdutoFiltrado.localizacaoOrigemId;
  const [localizacaoOrigemSelecionadaId, setLocalizacaoOrigemSelecionadaId] =
    useState(localizacaoOrigemId || "");

  // Localização de origem
  const localizacaoOrigem = selectedLoteInfo.localizacoes?.find(
    (l) =>
      l.localizacao?._id?.toString() ===
      localizacaoOrigemSelecionadaId?.toString(),
  );
  // Todas as localizações do lote exceto a origem — para o select de destino
  const quantidadeDisponivel = localizacaoOrigem?.quantidade || 0;
  const todasLocalizacoesLote =
    selectedLoteInfo.localizacoes?.filter((l) => l.quantidade > 0) || [];

  useEffect(() => {
    const fetchLocs = async () => {
      try {
        const res = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/localizacoes/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        );
        setTodasLocalizacoes((res.localizacoes || []).filter((l) => l.ativo));
      } catch (err) {
        console.error(err);
      }
    };
    if (open) fetchLocs();
  }, [open]);

  const localizacoesDestino = todasLocalizacoes.filter(
    (l) =>
      l.id !== localizacaoOrigemSelecionadaId &&
      l._id?.toString() !== localizacaoOrigemSelecionadaId,
  );

  const submit = async () => {
    if (!localizacaoDestinoId) return;

    startLoading();
    try {
      const formData = new FormData();
      formData.append("produtoId", stockRetirada.produto._id);
      formData.append("loteId", selectedLoteInfo._id);
      formData.append("localizacaoOrigemId", localizacaoOrigemSelecionadaId);
      formData.append("localizacaoDestinoId", localizacaoDestinoId);
      formData.append("quantidade", Number(quantidade));
      formData.append("responsavelId", auth.userId);

      const stockReturned = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/transferencia/${stock._id}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      atualizarStock(
        stockReturned.stock,
        "Transferência efetuada com sucesso!",
      );
      handleClose();
    } catch (err) {
      console.error("Erro ao transferir stock:", err);
    } finally {
      setIsSubmitting(false);
      stopLoading();
    }
  };

  const preSubmitHandler = () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      submit();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-transferencia-stock"
    >
      <Box
        className="fluxo-atendimento__modal__box retirarDoStock__modal"
        id="modal__cinquentaPorCento"
      >
        <h1 className="fluxo-atendimento__modal__titulo">
          Transferir produto entre localizações
        </h1>

        <div className="retirarDoStock__container">
          {/* Header com nome do produto */}
          <div className="retirarDoStock__container__header">
            <span className="retirarDoStock__container__nomeProduto">
              {stockRetirada.produto.nome}
              {stockRetirada.produto.classificacao === "MP" && (
                <span className="retirarDoStock__container__classificacao">
                  (Matéria Prima)
                </span>
              )}
            </span>
          </div>

          {/* Informações do lote */}
          <div className="retirarDoStock__container__lote-info">
            <div className="retirarDoStock__container__lote-header">
              <InventoryIcon className="retirarDoStock__container__lote-icon" />
              <h3>
                Lote: <strong>{nomeLote}</strong>
              </h3>
            </div>

            <div className="retirarDoStock__container__lote-detail">
              <span className="retirarDoStock__container__info-label">
                Quantidade Disponível:
              </span>
              <span className="retirarDoStock__container__info-value">
                {dadosProdutoFiltrado.selecionado?.quantidadeTotal || "N/A"}
              </span>
            </div>

            {selectedLoteInfo.dataValidade && (
              <div className="retirarDoStock__container__lote-detail">
                <span className="retirarDoStock__container__info-label">
                  Validade:
                </span>
                <span className="retirarDoStock__container__info-value">
                  {formatarDataGuardada(selectedLoteInfo.dataValidade)}
                </span>
              </div>
            )}
          </div>

          {/* Transferência — origem e destino */}
          <div className="retirarDoStock__container__lote-info">
            <div className="retirarDoStock__container__lote-header">
              <SwapHorizIcon className="retirarDoStock__container__lote-icon" />
              <h3>Transferência</h3>
            </div>

            {/* Origem */}
            <div className="retirarDoStock__container__lote-detail">
              <LocationOnIcon style={{ color: "#ef4444" }} />
              <span className="retirarDoStock__container__info-label">
                Origem:
              </span>
              {todasLocalizacoesLote.length > 1 ? (
                <div
                  className="customInputContainer"
                  style={{ marginBottom: 0, flex: 1 }}
                >
                  <select
                    value={localizacaoOrigemSelecionadaId}
                    onChange={(e) => {
                      setLocalizacaoOrigemSelecionadaId(e.target.value);
                      setQuantidade(1);
                    }}
                    className="customInputSelect"
                  >
                    {todasLocalizacoesLote.map((loc) => (
                      <option
                        key={loc.localizacao._id}
                        value={loc.localizacao._id}
                      >
                        {loc.localizacao.armazem?.codigo || "N/A"} /{" "}
                        {loc.localizacao.codigo} — {loc.localizacao.nome} (
                        {loc.quantidade} disp.)
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <span className="retirarDoStock__container__info-value">
                  {localizacaoOrigem?.localizacao?.armazem?.codigo || "N/A"} /{" "}
                  {localizacaoOrigem?.localizacao?.codigo || "N/A"} —{" "}
                  {localizacaoOrigem?.localizacao?.nome || ""}
                </span>
              )}
              <Chip
                size="small"
                label={`${quantidadeDisponivel} disponíveis`}
                color="primary"
                variant="outlined"
                style={{ marginLeft: 8 }}
              />
            </div>

            {/* Destino */}
            <div className="retirarDoStock__container__lote-detail">
              <LocationOnIcon
                className="retirarDoStock__container__detail-icon"
                style={{ color: "#22c55e" }}
              />
              <span className="retirarDoStock__container__info-label">
                Destino:
              </span>
              <div className="customInputContainer" style={{ marginBottom: 0 }}>
                <select
                  value={localizacaoDestinoId}
                  onChange={(e) => setLocalizacaoDestinoId(e.target.value)}
                  className="customInputSelect"
                >
                  <option value="">Selecione o destino</option>
                  {localizacoesDestino.map((loc) => (
                    <option key={loc.id} value={loc.id}>
                      {loc.armazem?.codigo || loc.armazem?.nome || "N/A"} /{" "}
                      {loc.codigo} — {loc.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Quantidade */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 2fr",
              gap: "15px",
            }}
          >
            <InputNumber
              initialValue={1}
              label="Qtd a Transferir"
              handleChange={(val) => setQuantidade(val)}
              min={1}
              max={quantidadeDisponivel}
              notEmpty={true}
            />
          </div>

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleClose}
              style={{ display: "block" }}
            >
              Fechar
            </span>
            <span
              disabled={isSubmitting || !localizacaoDestinoId}
              className="blue-button"
              onClick={preSubmitHandler}
              style={{
                opacity: !localizacaoDestinoId ? 0.5 : 1,
                cursor: !localizacaoDestinoId ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitting ? "Transferindo..." : "Transferir"}
            </span>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalTransferenciaStock;
